/**
 * @file Front Page
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import vHpHero from '../../components/hp-hero/hp-hero';
import vHpStories from '../../components/hp-stories/hp-stories';
import vStory from '../../components/story/story';
import vHpThreeCols from '../../components/hp-three-cols/hp-three-cols';
import vHpCoverage from '../../components/hp-coverage/hp-coverage';

/**
 * Front Page functions
 *
 * Runs js specific to the Front Page template
 */
const vFrontPage = () => {
	vHpHero();
	vStory();
	vHpStories();
	vHpThreeCols();
	vHpCoverage();

	gsap.registerPlugin(ScrollToPlugin);

	const internalLinks = document.querySelectorAll('[href^="#"]');
	[...internalLinks].forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			gsap.to(window, {
				duration: 1,
				scrollTo: {
					y:       link.getAttribute('href'),
					offsetY: 150,
				},
				ease: 'sine.out',
			});
		});
	});
};

if (document.readyState !== 'loading') {
	vFrontPage();
} else {
	document.addEventListener('DOMContentLoaded', vFrontPage);
}
